/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './enums';
import '../../connect/v2/common/money';
import '../../connect/v2/resources/location';
import '../../omg/fulfillment/fulfillment';
import '../../connect/v2/resources/error';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "channelcontrols": {
        "nested": {
          "configuration": {
            "nested": {
              "EntityIdentifier": {
                "fields": {
                  "merchantId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "channelId": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "locationId": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentConfiguration": {
                "fields": {
                  "entity": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pickupSettings": {
                    "type": ".squareup.channelcontrols.configuration.PickupSettings",
                    "id": 2,
                    "rule": "optional"
                  },
                  "deliverySettings": {
                    "type": ".squareup.channelcontrols.configuration.DeliverySettings",
                    "id": 3,
                    "rule": "optional"
                  },
                  "genericSettings": {
                    "type": ".squareup.channelcontrols.configuration.GenericSettings",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PickupSettings": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prepTimeDuration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentHoursAvailability": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentHoursAvailability",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "orderSubtotalMinimum": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isScheduledFulfillmentEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "enableEtaCalculation": {
                    "type": "bool",
                    "id": 100,
                    "rule": "optional"
                  },
                  "restrictedDates": {
                    "type": ".squareup.channelcontrols.configuration.RestrictedDates",
                    "id": 7,
                    "rule": "repeated"
                  },
                  "instructions": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  }
                }
              },
              "DeliverySettings": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "prepTimeDuration": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentHoursAvailability": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentHoursAvailability",
                    "id": 3,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "orderSubtotalMinimum": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 5,
                    "rule": "optional"
                  },
                  "isScheduledFulfillmentEnabled": {
                    "type": "bool",
                    "id": 6,
                    "rule": "optional"
                  },
                  "serviceFeeSettings": {
                    "type": ".squareup.channelcontrols.configuration.ServiceFeeSettings",
                    "id": 7,
                    "rule": "optional"
                  },
                  "restrictedDates": {
                    "type": ".squareup.channelcontrols.configuration.RestrictedDates",
                    "id": 8,
                    "rule": "repeated"
                  }
                }
              },
              "GenericSettings": {
                "fields": {
                  "orderThrottling": {
                    "type": ".squareup.channelcontrols.configuration.OrderThrottling",
                    "id": 1,
                    "rule": "optional"
                  },
                  "timezone": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "OrderThrottling": {
                "fields": {
                  "enablementStatus": {
                    "type": ".squareup.channelcontrols.configuration.EnablementStatus",
                    "id": 1,
                    "rule": "optional"
                  },
                  "maxOrderCountPerWindow": {
                    "type": "int32",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "FulfillmentHoursAvailability": {
                "fields": {
                  "hours": {
                    "type": ".squareup.connect.v2.resources.BusinessHoursPeriod",
                    "id": 1,
                    "rule": "repeated"
                  },
                  "useBusinessLocationHours": {
                    "type": "bool",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "ServiceFeeSettings": {
                "fields": {
                  "type": {
                    "type": ".squareup.channelcontrols.configuration.ServiceFeeType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "amountMoney": {
                    "type": ".squareup.connect.v2.common.Money",
                    "id": 2,
                    "rule": "optional"
                  },
                  "percentage": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              },
              "Target": {
                "fields": {
                  "type": {
                    "type": ".squareup.channelcontrols.configuration.TargetType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "id": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "PauseTargetConfig": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "pauseEndTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "pauseConfig": {
                    "type": ".squareup.channelcontrols.configuration.PauseConfig",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "PauseConfig": {
                "fields": {
                  "pauseEndTime": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.omg.fulfillment.FulfillmentType",
                    "id": 2,
                    "rule": "optional"
                  }
                }
              },
              "TargetOperationResult": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatus",
                    "id": 2,
                    "rule": "repeated"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "ResumeTargetConfig": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  }
                }
              },
              "TargetPauseStatus": {
                "fields": {
                  "target": {
                    "type": ".squareup.channelcontrols.configuration.Target",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatus",
                    "id": 2,
                    "rule": "repeated"
                  }
                }
              },
              "PauseStatus": {
                "fields": {
                  "isPaused": {
                    "type": "bool",
                    "id": 1,
                    "rule": "optional"
                  },
                  "currentPause": {
                    "type": ".squareup.channelcontrols.configuration.PauseInfo",
                    "id": 2,
                    "rule": "optional"
                  },
                  "fulfillmentType": {
                    "type": ".squareup.omg.fulfillment.FulfillmentType",
                    "id": 3,
                    "rule": "optional"
                  },
                  "endOfDayUtc": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "PauseInfo": {
                "fields": {
                  "status": {
                    "type": ".squareup.channelcontrols.configuration.PauseStatusType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "startTime": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "endTime": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  },
                  "source": {
                    "type": ".squareup.channelcontrols.configuration.PauseSource",
                    "id": 4,
                    "rule": "optional"
                  }
                }
              },
              "ConfigurationResult": {
                "fields": {
                  "entity": {
                    "type": ".squareup.channelcontrols.configuration.EntityIdentifier",
                    "id": 1,
                    "rule": "optional"
                  },
                  "configuration": {
                    "type": ".squareup.channelcontrols.configuration.FulfillmentConfiguration",
                    "id": 2,
                    "rule": "optional"
                  },
                  "errors": {
                    "type": ".squareup.connect.v2.resources.Error",
                    "id": 3,
                    "rule": "repeated"
                  }
                }
              },
              "RestrictedDates": {
                "fields": {
                  "startDate": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "endDate": {
                    "type": "string",
                    "id": 2,
                    "rule": "optional"
                  },
                  "recurrence": {
                    "type": "string",
                    "id": 3,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.EntityIdentifier && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentConfiguration && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PickupSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.DeliverySettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.GenericSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.OrderThrottling && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.FulfillmentHoursAvailability && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ServiceFeeSettings && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.Target && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseTargetConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.TargetOperationResult && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ResumeTargetConfig && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.TargetPauseStatus && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseStatus && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.PauseInfo && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.ConfigurationResult && !$root.nested?.squareup?.nested?.channelcontrols?.nested?.configuration?.nested?.RestrictedDates) {
  $root.addJSON(jsonData);
}

/**
 * EntityIdentifier represents a unique identifier for an entity in the fulfillment preferences hierarchy
 *
 * SOURCE EntityIdentifier @ squareup/channelcontrols/configuration/models.proto at 16:1
 */
export const EntityIdentifier = $root.lookupType('squareup.channelcontrols.configuration.EntityIdentifier');
fixType(EntityIdentifier);
Builder.createAndAttachToType(EntityIdentifier);
/**
 * SOURCE FulfillmentConfiguration @ squareup/channelcontrols/configuration/models.proto at 33:1
 */
export const FulfillmentConfiguration = $root.lookupType('squareup.channelcontrols.configuration.FulfillmentConfiguration');
fixType(FulfillmentConfiguration);
Builder.createAndAttachToType(FulfillmentConfiguration);
/**
 * SOURCE PickupSettings @ squareup/channelcontrols/configuration/models.proto at 40:1
 */
export const PickupSettings = $root.lookupType('squareup.channelcontrols.configuration.PickupSettings');
fixType(PickupSettings);
Builder.createAndAttachToType(PickupSettings);
/**
 * SOURCE DeliverySettings @ squareup/channelcontrols/configuration/models.proto at 87:1
 */
export const DeliverySettings = $root.lookupType('squareup.channelcontrols.configuration.DeliverySettings');
fixType(DeliverySettings);
Builder.createAndAttachToType(DeliverySettings);
/**
 * SOURCE GenericSettings @ squareup/channelcontrols/configuration/models.proto at 129:1
 */
export const GenericSettings = $root.lookupType('squareup.channelcontrols.configuration.GenericSettings');
fixType(GenericSettings);
Builder.createAndAttachToType(GenericSettings);
/**
 * SOURCE OrderThrottling @ squareup/channelcontrols/configuration/models.proto at 141:1
 */
export const OrderThrottling = $root.lookupType('squareup.channelcontrols.configuration.OrderThrottling');
fixType(OrderThrottling);
Builder.createAndAttachToType(OrderThrottling);
/**
 * SOURCE FulfillmentHoursAvailability @ squareup/channelcontrols/configuration/models.proto at 152:1
 */
export const FulfillmentHoursAvailability = $root.lookupType('squareup.channelcontrols.configuration.FulfillmentHoursAvailability');
fixType(FulfillmentHoursAvailability);
Builder.createAndAttachToType(FulfillmentHoursAvailability);
/**
 * --
 * @desc Details of the service fee including the type of fee, money or percentage amount
 *
 * SOURCE ServiceFeeSettings @ squareup/channelcontrols/configuration/models.proto at 163:1
 */
export const ServiceFeeSettings = $root.lookupType('squareup.channelcontrols.configuration.ServiceFeeSettings');
fixType(ServiceFeeSettings);
Builder.createAndAttachToType(ServiceFeeSettings);
/**
 * @desc Identifies a sales channel or scope targeted by a pause action.
 *
 * SOURCE Target @ squareup/channelcontrols/configuration/models.proto at 172:1
 */
export const Target = $root.lookupType('squareup.channelcontrols.configuration.Target');
fixType(Target);
Builder.createAndAttachToType(Target);
/**
 * SOURCE PauseTargetConfig @ squareup/channelcontrols/configuration/models.proto at 181:1
 */
export const PauseTargetConfig = $root.lookupType('squareup.channelcontrols.configuration.PauseTargetConfig');
fixType(PauseTargetConfig);
Builder.createAndAttachToType(PauseTargetConfig);
/**
 * SOURCE PauseConfig @ squareup/channelcontrols/configuration/models.proto at 195:1
 */
export const PauseConfig = $root.lookupType('squareup.channelcontrols.configuration.PauseConfig');
fixType(PauseConfig);
Builder.createAndAttachToType(PauseConfig);
/**
 * SOURCE TargetOperationResult @ squareup/channelcontrols/configuration/models.proto at 207:1
 */
export const TargetOperationResult = $root.lookupType('squareup.channelcontrols.configuration.TargetOperationResult');
fixType(TargetOperationResult);
Builder.createAndAttachToType(TargetOperationResult);
/**
 * SOURCE ResumeTargetConfig @ squareup/channelcontrols/configuration/models.proto at 218:1
 */
export const ResumeTargetConfig = $root.lookupType('squareup.channelcontrols.configuration.ResumeTargetConfig');
fixType(ResumeTargetConfig);
Builder.createAndAttachToType(ResumeTargetConfig);
/**
 * SOURCE TargetPauseStatus @ squareup/channelcontrols/configuration/models.proto at 222:1
 */
export const TargetPauseStatus = $root.lookupType('squareup.channelcontrols.configuration.TargetPauseStatus');
fixType(TargetPauseStatus);
Builder.createAndAttachToType(TargetPauseStatus);
/**
 * SOURCE PauseStatus @ squareup/channelcontrols/configuration/models.proto at 231:1
 */
export const PauseStatus = $root.lookupType('squareup.channelcontrols.configuration.PauseStatus');
fixType(PauseStatus);
Builder.createAndAttachToType(PauseStatus);
/**
 * SOURCE PauseInfo @ squareup/channelcontrols/configuration/models.proto at 249:1
 */
export const PauseInfo = $root.lookupType('squareup.channelcontrols.configuration.PauseInfo');
fixType(PauseInfo);
Builder.createAndAttachToType(PauseInfo);
/**
 * @desc Result of a single configuration operation in a bulk request.
 *
 * SOURCE ConfigurationResult @ squareup/channelcontrols/configuration/models.proto at 274:1
 */
export const ConfigurationResult = $root.lookupType('squareup.channelcontrols.configuration.ConfigurationResult');
fixType(ConfigurationResult);
Builder.createAndAttachToType(ConfigurationResult);
/**
 * --
 * @desc Represents a date range with special handling requirements, such as holidays or special events.
 * The date range can be a single day (start_date equals end_date) or span multiple days.
 * The range can have a recurrence pattern.
 *
 * SOURCE RestrictedDates @ squareup/channelcontrols/configuration/models.proto at 296:1
 */
export const RestrictedDates = $root.lookupType('squareup.channelcontrols.configuration.RestrictedDates');
fixType(RestrictedDates);
Builder.createAndAttachToType(RestrictedDates);